import { injectCss } from "../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.rt-base-editor__text-area.rt-persistent-editor__text-area{--base-editor-top-border-thickness:0}`);